import { Stack } from 'expo-router';
import React from 'react';

export default function SignupNavigator() {
  return (
    <Stack
      screenOptions={{
        headerBackVisible: true,
      }}
    />
  );
}
